import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MyLog } from '@common/common';
import { areDifferentValues, dateToStr, strToDate } from '@util/date-utils';
import { isJsObject } from '@util/utils';
import { Subscription } from 'rxjs';

let datePickerId = 1;

function generateDatePickerId() {
  datePickerId++
  return datePickerId;
}

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
})
export class DatePickerComponent implements OnInit {
  @Input() cls = '';

  @Input() label = '';

  @Input() name = '';

  @Input() rawInput = true;

  @Input() readonly = false;

  @Input('compare-mode') compareMode = 'day';

  ic = new UntypedFormControl(null);

  ic2 = new UntypedFormControl(null);

  changeSub!: Subscription;

  public _noHint = false;
  @Input('no-hint') set noHint(noHint: boolean) {
    this._noHint = noHint;
  }

  public _required = false;
  @Input() set required(req: boolean) {
    this._required = req;
    if (req) {
      this.ic.addValidators(Validators.required);
    } else {
      this.ic.removeValidators(Validators.required);
    }
  }

  private _lastEmitValue: any;

  public _value: string | Date | null = '';
  @Input() set value(value: any) {
    MyLog.log('DP:last:', this.value, this._lastEmitValue);
    MyLog.log('DP:value: ', value);

    this._value = value;
    if(isJsObject(value) && this.componentId === value.componentId) {
      return;
    }

    if (this.areDifferent(value, this._value) &&
      this.areDifferent(value, this._lastEmitValue)) {
        let replace = true;
      if (typeof value === 'string') {
        const d = this.strToDate(value);
        if (d) {
          value = d;
        }
      }

      if (value instanceof Date) {
        this._value = value;
        this.setFromInternalValue(replace);
      }
    } else {
      MyLog.log('DP:not different:', value, this._value);
    }
  }

  areDifferent(value1: any, value2: any) {
    return areDifferentValues(value1, value2, this.compareMode);
  }

  setFromInternalValue(replace:boolean, setControl=true) {
    if (this._value instanceof Date) {
      var s = dateToStr(this._value);

      if(replace) {
        this.ic.setValue(s, {
          emitEvent: false,
        });
      }

      if(setControl) {
// Sync with date picker input
this.ic2.setValue(this.value, {
  emitEvent: false,
});
      }
    }
  }

  strToDate(value: any) {
    return strToDate(value, this.compareMode);
  }

  @Output() valueChange = new EventEmitter<any>();

  @Output() afterValueChange = new EventEmitter();

  private _dic: any;
  @ViewChild('dic') set partnerRef(elem: ElementRef<any>) {
    this._dic = elem;
  }

  componentId = 1;

  constructor() {
    this.componentId = generateDatePickerId();
  }

  ngOnInit(): void {
    //MyLog.log('Date field init');
    this.changeSub = this.ic.valueChanges.subscribe((value: any) => {
      MyLog.log('CHANGE:', value);
      //this.checkDate(value);
    });
  }

  ngOnDestroy(): void {
    this.changeSub && this.changeSub.unsubscribe();
  }

  checkDate(value: any, force=false) {
    MyLog.log('CHECK:', value, this._value);

    if (typeof value === 'string') {
      const s = value.trim();
      if (!s) {
        MyLog.log('DATE:NOTHING:', this.name, value);
        this.doEmit(null);
        return;
      }
      const d = this.strToDate(s);
      MyLog.log('IN-DATE:', d);

      if (d) {
        (d as any).componentId = this.componentId;
        this.doEmit(d);
        return;
      }
      //this.valueChange.emit(s);
      MyLog.log('Invalid:', s);
      //return;
    }

    if (value instanceof Date) {
      (value as any).componentId = this.componentId;
      if(force) {
        this._value = value;
        this.setFromInternalValue(true,false);
      }
      this.doEmit(value);
      return;
    }
    this.doEmit(null);
  }

  private doEmit(value: any) {
    this._lastEmitValue = value;
    this.valueChange.emit(value);
  }

  filterInputKeyupFrom() {
    if (this._dic && this._dic.nativeElement) {
      const val = this._dic.nativeElement.value;
      MyLog.log('From input', val);
      this.checkDate(val);
    }
  }

  onDateChange($event: any) {
    MyLog.log('Picker: date change:', $event);
    $event && this.checkDate($event.value, true);
  }

  highlightError() {
    this.cls = 'error-highlight';
    setTimeout(() => {
      this.cls = '';
    }, 1000);
  }
}
